import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Profile from "../pages/profile/index"
import {BrowserRouter as Router} from "react-router-dom"

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.default,
    border: '1px solid #000',
    boxShadow: theme.shadows[5],
    width: 1000,
    maxHeight: 700,
    overflow: "auto",
    marginTop: 30,
  },
  close:{
    position: "absolute",
    width: 1000,
    textAlign: "right",
    paddingRight: 20,
    fontWeight: 800,
    fontSize: 24,
    "& span":{
      cursor: "pointer"
    }
  }
}));

const ProfileModal = ({setOpen})=>{
  const classes = useStyles()
  const [close, setClose] = useState(false)
  const handleClose = () => {
    setClose(true)
    setTimeout(()=> setOpen(false), 1)
  }
  return(
    <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={true}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
          <div className={classes.paper}>
            <div className={classes.close}><span onClick={handleClose}>X</span></div>
            <Router>
              <Profile close={close} />
            </Router>
          </div>
      </Modal>
  )
}

export default ProfileModal;
